<template>
  <div
    v-if="details"
    :class="$style.root"
  >
    <div
      v-if="label"
      :class="$style.label"
    >
      {{ label }}
    </div>

    <ul :class="$style.list">
      <li
        v-for="item in details"
        :key="item?.id"
        :class="$style.item"
      >
        <div
          v-if="item?.label"
          :class="$style.itemLabel"
        >
          {{ item.label?.trim() }}
        </div>
        <CoreTextComponent
          v-if="item?.value"
          :string="item.value"
          :class="$style.value"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
  const props = defineProps({
    label: {
      type: String,
      required: false,
    },
    details: {
      type: Array,
      required: true
    }
  })
</script>

<style module lang="scss">
.root {
  --block--margin-bottom: calc(var(--unit--vertical) * 2);
}

[class*='components-core-blocks-rich-text'] + .root {
  --block--margin-top: calc(var(--unit--vertical) * 2);
}

.label {
  composes: font-helvetica font-size-small label-border from global;
  text-align: center;
}

.list {
  composes: reset-list from global;

  columns: 2;

  @media (max-width: $breakpoint-s) {
    columns: 1;
  }

  margin-top: calc( (var(--font-default--line-height) / 2) * -1 );
  margin-bottom: calc( (var(--font-default--line-height) / 2) * -1 );
}

.item {
  padding: calc(var(--font-default--line-height) / 2) 0;
  break-inside: avoid;
}

.itemLabel {
  composes: font-helvetica font-size-small from global;
  line-height: var(--font-default--line-height);
}

.value {
  composes: font-size-default from global;
}

</style>
